import { render, staticRenderFns } from "./MedicosSolicitantesTabela.vue?vue&type=template&id=79427fee"
import script from "./MedicosSolicitantesTabela.vue?vue&type=script&lang=js"
export * from "./MedicosSolicitantesTabela.vue?vue&type=script&lang=js"
import style0 from "./MedicosSolicitantesTabela.vue?vue&type=style&index=0&id=79427fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports